import PropTypes from "prop-types";
import { Modal } from "@/config/antd";
import Button from "@/components/common/Button";
import { CloseOutlined } from "@/config/antd";
import { useNavigate } from "react-router-dom";
import { useLoader } from "@/hooks/LoaderProvider";

const AddTransactionDialog = ({ isVisible, onClose }) => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();

  const handleAddFunds = () => {
    onClose();
    showLoader();
    setTimeout(() => {
      hideLoader();
      navigate("/dashboard/financial/add-funds");
    }, 2000);
  };

  const handleAddExpense = () => {
    onClose();
    showLoader();
    setTimeout(() => {
      hideLoader();
      navigate("/dashboard/financial/add-expense");
    }, 2000);
  };

  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      centered
      width={600} // Increased width for better layout
      closeIcon={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
        mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
      }}>
      <div className="flex flex-col bg-white">
        {/* Header */}
        <div className="flex items-center justify-between p-4 px-6">
          <h2 className="font-bold text-medium text-primary">
            Add New Transaction
          </h2>
          <CloseOutlined
            onClick={onClose}
            className="cursor-pointer"
            style={{
              color: "var(--veegil-color-primary)",
              backgroundColor: "var(--veegil-color-secondary)",
              borderRadius: "50%",
              padding: "4px",
            }}
          />
        </div>

        {/* Content Area */}
        <div className="px-6 pb-6">
          {/* header */}
          <h2 className="mb-4 text-medium text-lighterGrey">
            Select below the type of transaction to create.
          </h2>
          <div className="grid grid-cols-2 gap-8">
            {/* Add Funds Option */}
            <div className="flex flex-col items-center">
              <div className="w-32 h-32 mb-4">
                <div className="flex items-center justify-center w-full h-full p-8 rounded-full bg-secondary">
                  <div className="flex items-center justify-center w-16 h-16 p-4 rounded-full bg-primary">
                    <span className="text-3xl text-white">$</span>
                  </div>
                </div>
              </div>
              <h3 className="mb-3 font-bold heading-medium">Add Funds</h3>
              <p className="mb-4 text-center text-regular text-lighterGrey">
                Add new funds to your account to manage your campaigns and
                events
              </p>
              <Button
                text="Add Funds"
                onClick={handleAddFunds}
                color="primary"
                customBgColor="primary"
                customTextColor="white"
                className="w-[185px] h-[43px]"
              />
            </div>

            {/* Add Expense Option */}
            <div className="flex flex-col items-center">
              <div className="w-32 h-32 mb-4">
                <div className="flex items-center justify-center w-full h-full p-8 rounded-full bg-secondary">
                  <div className="flex items-center justify-center w-16 h-16 p-4 rounded-full bg-primary">
                    <span className="text-3xl text-white">$</span>
                  </div>
                </div>
              </div>
              <h3 className="mb-3 font-bold heading-medium">Add Expense</h3>
              <p className="mb-4 text-center text-regular text-lighterGrey">
                Add an expense that needs to be made from the finance purse
              </p>
              <Button
                text="Add Expense"
                onClick={handleAddExpense}
                color="primary"
                customBgColor="primary"
                customTextColor="white"
                className="w-[185px] h-[43px]"
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="w-full p-4 bg-secondary">
          <Button
            text="CANCEL"
            color="secondary"
            className="w-full border border-primary"
            customBgColor="white"
            customTextColor="primary"
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};

AddTransactionDialog.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default AddTransactionDialog;
